import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header__block" }
const _hoisted_3 = { class: "header__block" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Тарифы ")
const _hoisted_5 = { class: "user-initials" }
const _hoisted_6 = { class: "nav-menu__content" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "Мои компании", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "Личный кабинет", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("hr", { class: "nav-menu__divider" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "Выход", -1)

import { ref } from "vue"

import DropdownIcon from "@layout/assets/icons/dropdown-icon.vue"
import ExitIcon from "@layout/assets/icons/exit-icon.vue"
import ProfileIcon from "@layout/assets/icons/profile-icon.vue"
import { BackButton } from "@layout/components"

import GtIcon from "@shared/components/ui/GtIcon.vue"
import IconUser from "@shared/components/icons/IconUser.vue"
import { useAuthStore } from "@auth/store/authStore"
import { getTextIcon } from "@global/utils/getTextIcon"
import { useShowTitle } from "@shared/composables/useShowTitle"
import { useRouter } from "vue-router"
import { PATHS } from "@global/utils/PATHS"
import { authService } from "@auth/services/authService"


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const isHideMenu = ref(false)

const showNavMenu = () => {
  isHideMenu.value = true
}

const hideMenu = () => {
  isHideMenu.value = false
}

/**
 * Показать подсказку при наведении на имя пользователя
 * (Показывается, если имя слишком длинное)
 * @param {object} event - объект события
 */
const { showTitle } = useShowTitle()

const authStore = useAuthStore()
const router = useRouter()

const logout = async () => {
  await authService.logout()
  authStore.removeAuthData()
  await router.push(PATHS.login)
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(BackButton), { class: "go-back__button" })
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_unref(authStore).user.organizationId)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            class: "header_link",
            to: {
          ..._unref(PATHS).companyDetail,
          params: {
            companyId: _unref(authStore).user.organizationId,
          },
        }
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(authStore).user.organizationName), 1)
            ]),
            _: 1
          }, 8, ["to"]))
        : _createCommentVNode("", true),
      _createVNode(_component_router_link, {
        class: "header_link",
        to: { name: 'tariffs' }
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }),
      _createElementVNode("div", {
        class: "user-info",
        onMouseenter: showNavMenu,
        onMouseleave: hideMenu
      }, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(getTextIcon)(_unref(authStore).user.name)), 1),
        _createElementVNode("div", {
          class: "user-name",
          onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (_unref(showTitle)($event, _unref(authStore).user.name)))
        }, _toDisplayString(_unref(authStore).user.name), 33),
        _createVNode(DropdownIcon, { class: "dropdown-icon" }),
        _createElementVNode("div", {
          class: _normalizeClass(["nav-menu", { 'show-nav-menu': isHideMenu.value }])
        }, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_router_link, {
              class: "nav-menu__item",
              to: { name: 'my-companies' }
            }, {
              default: _withCtx(() => [
                _createVNode(GtIcon, { class: "nav-menu__icon" }, {
                  default: _withCtx(() => [
                    _createVNode(IconUser)
                  ]),
                  _: 1
                }),
                _hoisted_7
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              class: "nav-menu__item",
              to: _unref(PATHS).profile
            }, {
              default: _withCtx(() => [
                _createVNode(ProfileIcon, { class: "nav-menu__icon" }),
                _hoisted_8
              ]),
              _: 1
            }, 8, ["to"]),
            _hoisted_9,
            _createElementVNode("button", {
              class: "nav-menu__item",
              type: "button",
              onClick: logout
            }, [
              _createVNode(ExitIcon, { class: "nav-menu__icon" }),
              _hoisted_10
            ])
          ])
        ], 2)
      ], 32)
    ])
  ]))
}
}

})